export default "__VITE_ASSET__DWTwol2a__"